export default "__VITE_ASSET__Fxn1fdSu__"